<template>
  <div
    v-if="title"
    class="sb-modal-header"
    :class="{ 'sb-modal-header--left': isLeftAlignment }"
  >
    <slot name="icon">
      <SbIconCircle v-if="icon" :variant="iconVariant">
        <SbIcon :name="icon" />
      </SbIconCircle>
    </slot>
    <div class="sb-modal-header__heading">
      <h1 class="sb-modal-header__title">
        {{ title }}
      </h1>
      <slot name="heading" />
    </div>

    <div v-if="slots.actions" class="sb-modal-header__actions">
      <slot name="actions" />
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed, useSlots } from 'vue'
import SbIcon from '../../Icon'
import SbIconCircle from '../../IconCircle'
import type { IconCircleVariant } from '../../IconCircle'
import type { IconName } from '../../Icon'

export type SbModalHeaderProps = {
  title?: string
  icon?: IconName
  align?: string
  iconVariant?: IconCircleVariant
}

const props = withDefaults(defineProps<SbModalHeaderProps>(), {
  title: undefined,
  icon: undefined,
  align: 'center',
  iconVariant: 'success',
})

const slots = useSlots()

const isLeftAlignment = computed(() => props.align === 'left')
</script>
